module.exports = __webpack_public_path__ + "sectionTopBanner.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/sectionTopBanner.jpg
// module id = 86
// module chunks = 0